'use strict';exports.__esModule = true;var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var omitLocationKeys = ['isFull', 'isCity', 'isNeighborhood', 'map', 'geocoded', 'city', 'street', 'house', 'key', 'tags', 'post_code', 'polygon', 'en.formatted_address', 'he.formatted_address'];

var formatFullAddress = function formatFullAddress(address) {
  var full_address = Object.assign({},
  (0, _omit2.default)(address, omitLocationKeys), {
    fr: null,
    ru: null });


  return full_address;
};exports.default =

formatFullAddress;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatFullAddress.js
// module id = 3066
// module chunks = 0